/* eslint-disable no-undef */
import {api} from './requestGraphql'

const getAffiliatePayments = async (data) => {
    try {
        data.affiliateId = (!data.affiliateId) ? '' : data.affiliateId

        // console.log('query:', `
        //         {
        //           affiliatePayments(
        //             filter: {
        //                 affiliateId: ${data.affiliateId}
        //             }
        //           )
        //         }
        //         `)

        const res = await api.post(
            '', {
                query: `
                {
                  affiliatePayments(
                    filter: {
                        affiliateId: ${data.affiliateId}
                    }
                  ) {
                    count
                      data {
                         id
                         date_added
                         amount
                         items_amount
                         total_revenue
                         carry_over_referral_commission
                         carry_over_amount
                         carry_over_modifications
                         referral_commission
                         start_period
                         end_period
                         status
                         billing_cycle
                         symbol
                         modifications
                         modification_note
                         partial_payments
                     }
                  }
                }        
                `,
            }
        )

        return {
            data: res.data.data.affiliatePayments.data,
            count: res.data.data.affiliatePayments.count
        }

    } catch (err) {
        console.error(err)
        throw err;
    }
}

export default {
    getAffiliatePayments,
}
